import React, { useState } from 'react';
import axios from 'axios';
import { APP_API_URL } from '../../utils';
import Swal from 'sweetalert2';
import DuoModal from '../../components/ui/duo-modal';

export default function Delete({ open, onClose, category, refreshData }) {
  const [isLoading, setLoading] = useState(false);

  if (!open || !category) return null;

  const handleDelete = async () => {
    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      const response = await axios.delete(`${APP_API_URL}/categories/${category.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        await Swal.fire({
          icon: 'success',
          title: 'Succès',
          text: response.data.message || 'La catégorie a été supprimée avec succès.',
          timer: 2000,
          showConfirmButton: false,
        });
        onClose();
        refreshData();
      }
    } catch (error) {
      console.error('Erreur lors de la suppression de la catégorie', error);
      Swal.fire({
        icon: 'error',
        title: 'Erreur',
        text: 'Une erreur est survenue lors de la suppression. Veuillez réessayer.',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <DuoModal
      title="Supprimer une catégorie"
      onClose={onClose}
      footer={
        <>
          <button type="button" className="duo-btn duo-btn--ghost" onClick={onClose} disabled={isLoading}>
            Annuler
          </button>
          <button
            type="button"
            className="duo-btn duo-btn--danger"
            onClick={handleDelete}
            disabled={isLoading}
          >
            {isLoading ? 'Suppression...' : 'Supprimer'}
          </button>
        </>
      }
    >
      <div className="duo-modal__hero">
        <i className="bi bi-exclamation-triangle-fill duo-modal__hero-icon" style={{ color: '#ff4b4b' }} aria-hidden />
        <p className="duo-modal__hero-text">
          Voulez-vous vraiment supprimer la catégorie <strong>{category.nom}</strong> ?
          Cette action est irréversible.
        </p>
      </div>
    </DuoModal>
  );
}
